import { DescripUnion } from '@Models/types';

//helper for components that handle both jira and aha descrips
export const getFields = (obj: DescripUnion) => {
  if ('reference_num' in obj && 'name' in obj) {
    return {
      id: obj.reference_num,
      title: obj.name,
      description_body: obj.description_body,
      context: obj.context,
    };
  } else {
    return {
      id: obj.key,
      title: obj.summary,
      description_body: obj.description_body,
      context: obj.context,
    };
  }
};
